module.exports = __webpack_public_path__ + "img/card-3.a2b58ac5.svg";